<template>
  <div class="employee-compliance-all">
    <div class="row">
      <div
        class="col-12 d-flex justify-content-between align-items-center pb-2"
      >
        <div class="d-flex align-items-center">
          <div class="date align-self-center">{{ dateText }}</div>
        </div>
        <div class="d-flex">
          <employee-compliance-filter v-model="filter" @filter="applyFilter" />
          <button type="button" class="btn wfh-btn-primary-outline btn-sm ml-2" @click="processExport">
            Download Report
          </button>
        </div>
      </div>
    </div>

    <div>
      <employee-compliance-item
        v-for="staff in staffs"
        :key="staff.id"
        :staff="staff"
        :date="date"
        :timezone="timezone"
      />
    </div>

    <div class="text-center" v-if="staffs.length < pagination.totalItem">
      <button
        class="btn btn-link font-weight-bold text-accent p-0"
        @click="fetchStaffs()"
      >
        Show more
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['user'],

  data() {
    return {
      timezone: null,
      date: '',
      filter: {
        teamId: '',
        term: '',
        date: '',
      },
      staffs: [],
      pagination: {
        page: 0,
        totalItem: 0,
      },
    }
  },

  computed: {
    dateText() {
      if (this.date === '') {
        return moment().format('MMMM Do')
      }

      if (typeof this.date === 'string') {
        return moment(this.date).format('MMMM Do')
      }

      return `${moment(this.date.start).format('MMMM Do')} - ${moment(this.date.end).format('MMMM Do')}`
    },
  },

  methods: {
    getParams (all = false) {
      let params = {
        'status': 'active',
        'q': this.filter.term,
      }

      if(this.filter.teamId) {
        params['group_ids'] = ([this.filter.teamId])
      }

      if(all) {
        params['page'] = this.pagination.page
      }

      return params
    },

    async fetchTimezone() {
      const res = await axios.get('/me')

      this.timezone = res.data?.data?.office_timezone?.zone_name || null
    },

    async fetchStaffs() {
      this.pagination.page += 1
      const res = await axios.get(`/team-members/add-list`, {
        params: this.getParams()
      });

      this.date = this.filter.date === '' ? moment().format('YYYY-MM-DD') : this.filter.date
      this.staffs = [...this.staffs, ...res.data.data]
      this.pagination.page = res.data.current_page
      this.pagination.totalItem = res.data.total
    },

    processExport() {
      const params = this.getParams(true);

      if (!!this.filter['date']) {
        params['start_date'] = this.filter['date'].start;
        params['end_date'] = this.filter['date'].end;
      }
      window.open('/staff-compliance/export/report?' + new URLSearchParams(params).toString());
    },

    applyFilter() {
      this.staffs = []
      this.pagination.page = 0
      this.pagination.totalItem = 0
      this.fetchStaffs()
    },
  },

  mounted() {
    this.fetchStaffs()
    this.fetchTimezone()
  },
};
</script>

<style lang="scss" scoped>
.employee-compliance-all {
  .date-today {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;

    @media (max-width: 768px) {
      font-size: 14px;
    }
  }

  .date {
    color: #808fa4;
    font-family: "Open Sans";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
}

.card {
  background-color: #f2f2f2;
}
</style>
